import Icon from './Icon'

export default Icon



// WEBPACK FOOTER //
// ./app/components/Icon/index.js